import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { SecurityService } from '../Security/security.service';
import { LogService } from '../Abstract/log.service';
import { VisualsService } from '../Abstract/visuals.service';
import { Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';

@Component({
    selector: 'base-crud',
    template: ''
})

export class BaseCRUDComponent<T extends SecurityService> implements OnInit {

    protected visuals:any = {};
    protected genericVisuals:any = {};
    protected group:string;
    protected urlParams:any = {};
    protected bean:any = {};
    protected loading:boolean = false;
    protected submiting:boolean = false;
    protected editForm : UntypedFormGroup;
    protected validationMessages= {};
    protected getValidationMessages():void{};
     
 // protected dateRegex = /(^(((0[1-9]|[12][0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
    protected dateRegex = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
    protected intRegex = /(^[0-9]\d*$)/;
    protected alphanumeric=/^[a-zA-Z0-9]+$/;
    protected alpha = /^[a-zA-Z ]*$/;
    protected swiftCode = /^[ A-Za-z0-9/?:().,'+=-]*$/;  
    protected nonalpha = /^[0-9*!@#\$%\^\&*\)\(+=._-]+$/
    protected email =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    protected decimalRegex = /^[0-9]+(\.[0-9]{1,2})?$/; 

    //Used to show user's choice on confirmation modal
    protected requestActionMsg:any= {};
    protected confirmationMsg = "";
    protected confirmationLoader = false;
    protected confirmationFlag = "";
    protected fieldArray : any[] = [];

    constructor(protected logger: LogService, protected visualsService: VisualsService, 
                protected route: ActivatedRoute, protected fb:UntypedFormBuilder, protected router:Router){
      
    }

    ngOnInit(): void {
        this.loadVisuals();
        this.fillView();
        this.initLoadBean();
    }

    protected fillView(){}

    protected loadVisuals():void{
        this.getGenericVisuals();
        this.getVisuals();
    }

    protected getVisuals(){
        this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
        this.getValidationMessages();
    }

    protected getGenericVisuals(){
        this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
    }

    protected loadBean(map:Map<string, any>):any{}

    protected save(bean:any){}

    protected initLoadBean(){
        this.urlParams = {};

        this.route.queryParams.subscribe(
            params => {
                this.logger.warn(params);
                this.urlParams = params;
                if(this.loadBean(this.urlParams) != null){
                this.loading = true;
            }
            error => {
               return throwError(error);
            }
        });
    }
    groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      };
    mapFields(fields: any[]): { fields: any[], options: any } {
        let formState: any = {};
        let formlyFields = fields.map(fl => {
        fl.label = this.visuals[fl.label];
          fl.fields.map(el=>{
          this.mapFieldGroups(el, formState);
          })
            return fl;
        });

        let formlyOptions: any = {
            formState: formState  // Populate formState here
        };
    
        return { fields: formlyFields, options: formlyOptions };
    }
     
    mapFieldGroups(fieldArray: any,formState: any) {
        if (fieldArray.hasOwnProperty('fieldGroup')) {
            fieldArray['fieldGroup'].map(fieldGroup => {
              if (fieldGroup.hasOwnProperty('fieldGroup')){
                fieldGroup['fieldGroup'].map(nestedFieldGroup => {
                  this.templateOptionsMapping(nestedFieldGroup,formState);
                if (nestedFieldGroup.hasOwnProperty('fieldArray')) {
                    this.mapFieldGroups(nestedFieldGroup['fieldGroup'],formState);
                }
                })
              }
              else{
                this.templateOptionsMapping(fieldGroup,formState);
                if (fieldGroup.hasOwnProperty('fieldArray')) {
                    this.mapFieldGroups(fieldGroup['fieldArray'],formState);
                }
              }
             
            });
        }
    }
    
    templateOptionsMapping(formlyOption:any,formState:any):any {
        if(formlyOption.templateOptions && formlyOption.templateOptions.options) {
            if(formlyOption.templateOptions.isnotLKP){
                formlyOption.templateOptions.options = this[formlyOption.templateOptions.options];
            }
            else{
                formlyOption.templateOptions.options = this.visualsService.getLkpFromStorageAsJSON(formlyOption.templateOptions.options, true);
            }
        }
        if(formlyOption.templateOptions){
            formlyOption.templateOptions.label = formlyOption.key ? this.visuals[formlyOption.key] : this.visuals[formlyOption.templateOptions.label];
            formlyOption.templateOptions.innerLabel = this.visuals[formlyOption.templateOptions.innerLabel];
            formlyOption.templateOptions.addButton = this.visuals[formlyOption.templateOptions.addButton];
        }
        if (formlyOption.templateOptions && formlyOption.templateOptions.change) {
            formlyOption.templateOptions.change = Function('$index', '$event', formlyOption.templateOptions.change).bind(this);
        }
        if (formlyOption.templateOptions && formlyOption.templateOptions.onClick) {
            formlyOption.templateOptions.onClick = Function('field', '$event', formlyOption.templateOptions.onClick).bind(this);
        }

        // Dynamically create hooks for onInit and onChange
        if (formlyOption.hooks) {
            // onInit hook
            if (formlyOption.hooks.onInit == 'initFormState') {
                formlyOption.hooks.onInit = (field) => {
                    // Store a reference to this.fieldArray to access it in valueChanges
                    const fieldArrayRef = this.fieldArray;
                    const existingField = fieldArrayRef.find(item => item.key === field.key);
                    // Only add the field if it does not already exist
                    if (!existingField) {
                        fieldArrayRef.push(field);
                    }
                    // Initialize formState values
                    field.options.formState[formlyOption.key] = field.model[formlyOption.key];
                    formState[formlyOption.key] = field.model[formlyOption.key];
                    field.options.formState = { ...field.options.formState, ...formState };
                    field.formControl.valueChanges.subscribe((newValue) => {
                        field.options.formState[formlyOption.key] = newValue;
                        formState[formlyOption.key] = newValue;
                        field.options.formState = { ...field.options.formState, ...formState };
                        fieldArrayRef.forEach(otherField => {
                            if (otherField.key !== formlyOption.key) {
                                // Update formState for each other field in fieldArrayRef
                                otherField.options.formState = { ...otherField.options.formState, ...formState };
                            }
                        });
            
                    });

                };
            }
            // // onChange hook Not Supported yet in 5.12.7.Left it here when update in latest version
            // if (formlyOption.hooks.onChange == 'changeFormState') {
            //     formlyOption.hooks.onChange = (field) => {
            //         field.options.formState[formlyOption.key] = field.formControl.value;
            //     };
            // }   
        }
        // // // onChange hook Not Supported yet in 5.12.7.this is a temp alternative. Problem is previous value is beeing displayed
        // if (formlyOption.templateOptions && formlyOption.templateOptions.onChange) {
        //     let onChangeFunctionName = formlyOption.templateOptions.onChange;
        //     if (typeof this[onChangeFunctionName] === 'function') {
        //         // Dynamically bind the onChange function to keyup event
        //         formlyOption.templateOptions.keyup = (field, event) => {
        //             this[onChangeFunctionName](field);
        //         };
        //     }
        // }
    }

    // public changeFormState(field) {
    //     // Update the formState with the current model value
    //     field.options.formState[field.key] = field.formControl.value;
    //     // this.cdr.detectChanges();
    //     // console.log(field.options.formState[field.key]);
    // }

}